import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { API_URL } from "../api/api";

const AdminProtectedRoute = () => {
  const token = localStorage.getItem('token');
  const userID = localStorage.getItem('userID');
  const userRole = localStorage.getItem('userRole');

  const [isVerified, setIsVerified] = useState(null); // null = loading, true/false = decision

  useEffect(() => {
    const verifyUser = async () => {
      if (!token || userRole !== 'admin') {
        setIsVerified(false);
        return;
      }
      try {
        const response = await axios.get(`${API_URL}/user/${userID}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response?.data?.status === "active") {
          setIsVerified(true);
          localStorage.setItem('isActive', JSON.stringify(true));
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'Some function restricted',
            text: 'Your account is not active. Please contact support.',
          });
          localStorage.setItem('isActive', JSON.stringify(false));
          setIsVerified(true);
        }
      } catch (error) {
        console.error("Error verifying user status", error);
        Swal.fire({
          icon: 'error',
          title: 'Unauthorized',
          text: 'Session expired or invalid. Please login again.',
        });
        setIsVerified(false);
      }
    };

    verifyUser();
  }, [token, userRole]);

  if (isVerified === null) {
    return <div>Loading...</div>; // Optional: Replace with spinner
  }

  if (!isVerified) {
    return <Navigate to="/adminLogin" replace />;
  }

  return <Outlet />;
};

export default AdminProtectedRoute;
